export const injectArgsToPath = (endpoint = '', args = {}, prefix = ':') => {
  let result = endpoint

  Object.entries(args).forEach(([key, value]) => {
    const newReg = new RegExp(`${prefix}${key}`, 'gi')
    result = result.replace(newReg, value)
  })
  return result
}

export const injectParamsToPath = (endpoint= '', args = {}) => {
  return endpoint.concat(new URLSearchParams(args).toString());
}
